// extracted by mini-css-extract-plugin
export default {"customTypography":"CustomTypography_customTypography__ogQbh"};